(function () {
  'use strict';

  // ==========================================
  // PRODUCT CONFIGURATIES
  // ==========================================

  var PRODUCTS = {

    // PRODUCT 1: RUNNING BELT BUNDEL WIT
    'running-belt-bundel-wit': {
      groupFlasks: true,

      gifts: {
        '8706d602-5051-4148-a55c-ece363b17376': 1,
        '7ab23c40-ae8f-45de-8bcb-5b03e9461c1b': 2,
        'd_cS': 3
      },

      giftImage: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/300_-_z_72d7ba05-199b-4409-b1a4-01f777f17738.jpg?v=1763464416',
      giftTextKey: 'kaching_free_soft_flask_300ml',
      giftText: '+ GRATIS Soft Flask 300 ML',
      giftPrice: '10,95',

      shippingGift: {
        barId: '7ab23c40-ae8f-45de-8bcb-5b03e9461c1b',
        barIds: ['d_cS'],
        image: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/belt_in_zakje.png?v=1789251488',
        textKey: 'kaching_free_shipping',
        text: '+ GRATIS Verzending'
      },

      imageOverrides: [
        {
          color: 'ZWART',
          old: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/BELT_ZWART_FLESJE.jpg?v=1766610565',
          new: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/belt_bf87dc95-1b8e-4e2c-b70e-d14cd451feb8.jpg?v=1763463436'
        },
        {
          color: 'WIT',
          old: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/white_belt_black_bottle.png?v=1773707974',
          new: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/White_belt.png?v=1763463436'
        },
        {
          color: 'ROZE',
          old: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/Pink_belt_black_bottle.png?v=1773707974',
          new: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/Pink_belt.png?v=1763463436'
        }
      ]
    },

    // PRODUCT 2: RUNNING BELT INCLUSIEF FLASK
    'running-belt-inclusief-flask': {
      groupFlasks: true,

      gifts: {
        '8706d602-5051-4148-a55c-ece363b17376': 1,
        '7ab23c40-ae8f-45de-8bcb-5b03e9461c1b': 2,
        'd_cS': 3,
        '2d0a313b-b37a-4b01-8cab-557734d26692': 1,
        '67d7ba44-f0d3-4a1a-abe3-4107b151bb66': 3
      },

      giftImage: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/300_-_z_72d7ba05-199b-4409-b1a4-01f777f17738.jpg?v=1763464416',
      giftTextKey: 'kaching_free_soft_flask_300ml',
      giftText: '+ GRATIS Soft Flask 300 ML',
      giftPrice: '10,95',

      shippingGift: {
        barId: '7ab23c40-ae8f-45de-8bcb-5b03e9461c1b',
        barIds: ['d_cS', '67d7ba44-f0d3-4a1a-abe3-4107b151bb66'],
        image: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/belt_in_zakje.png?v=1789251488',
        textKey: 'kaching_free_shipping',
        text: '+ GRATIS Verzending'
      },

      imageOverrides: [
        {
          color: 'ZWART',
          old: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/BELT_ZWART_FLESJE.jpg?v=1766610565',
          new: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/belt_bf87dc95-1b8e-4e2c-b70e-d14cd451feb8.jpg?v=1763463436'
        },
        {
          color: 'WIT',
          old: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/white_belt_black_bottle.png?v=1773707974',
          new: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/White_belt.png?v=1763463436'
        },
        {
          color: 'ROZE',
          old: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/Pink_belt_black_bottle.png?v=1773707974',
          new: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/Pink_belt.png?v=1763463436'
        }
      ]
    },

    // PRODUCT 3: RUNNING VEST INCLUSIEF FLASKS
    'running-vest-inclusief-2-flasks': {
      productName: 'Running Vest',

      gifts: {
        '982b659d-cd19-4fcc-89e9-122c203bb8a7': 1,
        '4a53a0d8-6cb8-4cde-9864-0c2f312fbcf3': 2
      },

      giftImage: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/2_blauwe_flasks.png?v=1778597104',
      giftTextKey: 'kaching_free_2x_soft_flask_500ml',
      giftText: '+ 2x GRATIS Soft Flask 500 ML',
      giftPrice: '19,95',

      extraGift: {
        // Houd de Mystery Gift altijd onder alle Kaching-cadeaus.
        last: true,
        barId: '4a53a0d8-6cb8-4cde-9864-0c2f312fbcf3',
        image: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/Mystery_gift.png?v=1790081872',
        textKey: 'kaching_free_mystery_gift',
        text: '+ GRATIS Mystery Gift'
      },

      imageOverrides: [
        {
          color: 'ZWART',
          old: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/zwart_met_blauwe_flessen.png?v=1780519872',
          new: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/zwart_voor.png?v=1776548918'
        },
        {
          color: 'WIT',
          old: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/white_vest_A_43406001-4a94-437b-b065-8fb8bd55985d.jpg?v=1789823119',
          new: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/wit_voor.png?v=1776548918'
        }
      ]
    },

    // PRODUCT 4: RUNNING BELT ZIPPER INCLUSIEF FLASK
    'running-belt-zipper-inclusief-flask': {
      productName: 'Running Belt Zipper',
      groupFlasks: true,
      groupedGratisFirst: false,

      gifts: {
        'd73fc8e3-f1a0-4f09-a767-328c3ba6807c': 1,
        '89f42fd8-96e6-44dc-8c3b-b4aa7576d41b': 2,
        '5qBw': 3 // 2+1 GRATIS: drie GRATIS flasks bij drie belts.
      },

      giftImage: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/300_-_z_72d7ba05-199b-4409-b1a4-01f777f17738.jpg?v=1763464416',
      giftTextKey: 'kaching_free_soft_flask_300ml',
      giftText: '+ GRATIS Soft Flask 300 ML',
      giftPrice: '10,95',

      shippingGift: {
        barId: '89f42fd8-96e6-44dc-8c3b-b4aa7576d41b',
        barIds: ['5qBw'],
        image: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/belt_in_zakje.png?v=1789251488',
        textKey: 'kaching_free_shipping',
        text: '+ GRATIS Verzending'
      },

      imageOverrides: [
        {
          color: 'ZWART',
          old: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/NEW_BELT_-_BLACK_FLASK.png?v=1766609902',
          new: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/NEW_BELT.png?v=1756643363'
        }
      ]
    }
  };

  // ==========================================
  // PRODUCT ALIASES
  // ==========================================

  PRODUCTS['running-belt-zipper-bundel-2'] =
    PRODUCTS['running-belt-zipper-inclusief-flask'];

  PRODUCTS['running-vest-bundel-2'] =
    PRODUCTS['running-vest-inclusief-2-flasks'];

  PRODUCTS['running-belt-bundel-2'] =
    PRODUCTS['running-belt-inclusief-flask'];

  PRODUCTS['running-vest-including-2-flasks'] =
    PRODUCTS['running-vest-inclusief-2-flasks'];

  PRODUCTS['running-belt-including-flask'] =
    PRODUCTS['running-belt-inclusief-flask'];

  PRODUCTS['running-belt-zipper-including-flask'] =
    PRODUCTS['running-belt-zipper-inclusief-flask'];

  PRODUCTS['running-vest-bundle-2'] =
    PRODUCTS['running-vest-bundel-2'];

  PRODUCTS['running-belt-bundle-2'] =
    PRODUCTS['running-belt-bundel-2'];

  PRODUCTS['running-belt-zipper-bundle-2'] =
    PRODUCTS['running-belt-zipper-bundel-2'];

  PRODUCTS['running-belt-bundel'] =
    PRODUCTS['running-belt-inclusief-flask'];

    PRODUCTS['running-belt-bundel-listicle'] =
  PRODUCTS['running-belt-inclusief-flask'];

  PRODUCTS['running-vest-bundel'] =
    PRODUCTS['running-vest-inclusief-2-flasks'];

    
  // ==========================================
  // RUNNING VEST - STANDAARD PAGINA'S
  // ==========================================

  var VEST_STANDARD_CONFIG = {
    gifts: {
      '992014f2-39e1-45d8-bb8d-5b998b8620bb': 0
    },

    extraGift: {
      last: true,
      barId: '992014f2-39e1-45d8-bb8d-5b998b8620bb',
      image: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/Mystery_gift.png?v=1790081872',
      textKey: 'kaching_free_mystery_gift',
      text: '+ GRATIS Mystery Gift'
    },

    variantImageBars: []
  };

  PRODUCTS['running-vest'] = VEST_STANDARD_CONFIG;
  PRODUCTS['running-vest-2'] = VEST_STANDARD_CONFIG;

    
  // ==========================================
  // RUNNING BELT ZIPPER - STANDAARD PAGINA'S
  // ==========================================

  var ZIPPER_STANDARD_CONFIG = {
    productName: 'Running Belt Zipper',

    // Geen nieuwe gifts toevoegen of aanpassen.
    gifts: {},

    // A/B-test: beide aanbiedingen ondersteunen.
    variantImageBars: [
      '7e492de5-7a0b-48e8-8eb5-c610517cb015', // 1 Belt
      '0e3c2397-75cb-4c50-96e7-bfcdfbe6dd80', // A: 2+1 GRATIS
      'qGzy' // B: 2 Belts + GRATIS Flasks
    ],

    // Exact dezelfde productfoto's als Zipper inclusief Flask.
    imageOverrides:
      PRODUCTS['running-belt-zipper-inclusief-flask'].imageOverrides
  };

  PRODUCTS['running-belt-zipper'] =
    ZIPPER_STANDARD_CONFIG;

  PRODUCTS['running-belt-zipper-2'] =
    ZIPPER_STANDARD_CONFIG;


  // ==========================================
  // GRATIS VERZENDING - LOSSE BELT-PAGINA'S
  // ==========================================

  // ZIPPER: bestaande configuratie uitbreiden.
  ZIPPER_STANDARD_CONFIG.gifts = {
    'qGzy': 0,
    '0e3c2397-75cb-4c50-96e7-bfcdfbe6dd80': 0
  };

  ZIPPER_STANDARD_CONFIG.shippingGift = {
    barIds: [
      'qGzy',
      '0e3c2397-75cb-4c50-96e7-bfcdfbe6dd80'
    ],
    image: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/belt_in_zakje.png?v=1789251488',
    textKey: 'kaching_free_shipping',
    text: '+ GRATIS Verzending'
  };

  // RUNNING BELT: configuratie voor de losse pagina's.
  var BELT_STANDARD_CONFIG = {
    gifts: {
      '98c93a18-a834-47c4-bf6a-c867fa331ff5': 0,
      'ROZt': 0,
      'd0lm': 0
    },

    shippingGift: {
      barIds: [
        '98c93a18-a834-47c4-bf6a-c867fa331ff5',
        'ROZt',
        'd0lm'
      ],
      image: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/belt_in_zakje.png?v=1789251488',
      textKey: 'kaching_free_shipping',
      text: '+ GRATIS Verzending'
    },

    variantImageBars: []
  };

  PRODUCTS['running-belt'] = BELT_STANDARD_CONFIG;
  PRODUCTS['running-belt-1'] = BELT_STANDARD_CONFIG;
  PRODUCTS['running-belt-2'] = BELT_STANDARD_CONFIG;


  // ==========================================
  // ACTIEVE PRODUCT CONFIGURATIE
  // ==========================================

  var pageMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (!pageMatch) return;

  var handle = decodeURIComponent(pageMatch[1]);
  var config = PRODUCTS[handle];
  if (!config) return;

  var GIFT_ATTR = 'data-zone2-new-kaching-gift';
  var DIVIDER_ATTR = 'data-zone2-new-kaching-divider';
  var scheduled = false;

  var COLOR_DROPDOWN_SELECTOR =
    '.kaching-bundles__swatch-dropdown[data-name="Kleur"], ' +
    '.kaching-bundles__swatch-dropdown[data-name="Color"], ' +
    '.kaching-bundles__swatch-dropdown[data-name="Colour"]';

  var COLOR_ALIASES = {
    BLACK: 'ZWART',
    WHITE: 'WIT',
    PINK: 'ROZE'
  };

  function normalizeColor(value) {
    var color = String(value || '').trim().toUpperCase();
    return COLOR_ALIASES[color] || color;
  }

  // ==========================================
  // VERTALINGEN
  // ==========================================

  function translate(key, fallback) {
    var value = key && window.z2Translations && window.z2Translations[key];

    if (!value || /^translation missing/i.test(String(value))) {
      return fallback || '';
    }

    return String(value);
  }

  // ==========================================
  // CADEAUREGEL MAKEN
  // ==========================================

  function createGift(index, amount, type) {
    var height = (amount >= 2 || type === 'extra') ? 40 : 30;
    var isExtra = type === 'extra';
    var isGrouped = type === 'flask-group';

    var extra = config.extraGift || config.shippingGift;
    var image = isExtra ? extra.image : config.giftImage;

    var text = isExtra
      ? translate(extra.textKey, extra.text)
      : translate(config.giftTextKey, config.giftText);

    // Bijvoorbeeld:
    // + 2x GRATIS Soft Flask 300 ML
    // + 3x GRATIS Soft Flask 300 ML
    if (isGrouped) {
      var cleanText = text.replace(/^\s*\+\s*/, '').trim();

      if (config.groupedGratisFirst) {
        // Optionele tekstvolgorde: + GRATIS 2x Soft Flask 300 ML.
        var parts = cleanText.match(/^(\S+)\s+(.+)$/);
        text = parts
          ? '+ ' + parts[1] + ' ' + amount + 'x ' + parts[2]
          : '+ ' + amount + 'x ' + cleanText;
      } else {
        // Open belt en Zipper: + 2x / 3x GRATIS Soft Flask 300 ML.
        text = '+ ' + amount + 'x ' + cleanText;
      }
    }

    // Tel de doorgestreepte waarde van de flasks bij elkaar op.
    var giftPrice = config.giftPrice;

    if (isGrouped && giftPrice) {
      var unitPrice = Number(String(giftPrice).replace(',', '.'));

      giftPrice = Number.isFinite(unitPrice)
        ? (unitPrice * amount).toFixed(2).replace('.', ',')
        : '';
    }

    var gift = document.createElement('div');
    gift.className = 'kaching-bundles__free-gift';
    gift.setAttribute(GIFT_ATTR, String(index));

    if (isGrouped) {
      gift.setAttribute('data-zone2-grouped-flasks', String(amount));
    }

    gift.setAttribute(
      'style',
      '--kaching-free-gift-background-color: rgba(141, 141, 141, 1);' +
      '--kaching-free-gift-text-color: rgba(255, 255, 255, 1);' +
      '--kaching-free-gift-selected-background-color: rgba(0, 0, 0, 1);' +
      '--kaching-free-gift-selected-text-color: rgba(255, 255, 255, 1);' +
      '--kaching-free-gift-font-size: 13px;' +
      '--kaching-free-gift-font-weight: 500;' +
      '--kaching-free-gift-font-style: normal;' +
      '--kaching-free-gift-image-border-radius: 4px;' +
      '--kaching-free-gift-image-height: ' + height + 'px;'
    );

    gift.innerHTML =
      '<div class="kaching-bundles__free-gift__main">' +
        '<div class="kaching-bundles__free-gift__link">' +
          '<img alt="" class="kaching-bundles__free-gift__image" height="' +
            height + '"' +
            (isGrouped ? ' hidden' : ' src="' + image + '"') +
          '>' +
        '</div>' +
        '<div class="kaching-bundles__free-gift__content">' +
          '<span class="kaching-bundles__free-gift__text"></span>' +
        '</div>' +
      '</div>' +
      (isExtra || !giftPrice ? '' :
        '<div class="kaching-bundles__free-gift__full-price">' +
          giftPrice +
        '</div>');

    gift.querySelector(
      '.kaching-bundles__free-gift__text'
    ).textContent = text;

    return gift;
  }

  // ==========================================
  // CADEAUREGELS EN VOLGORDE
  // ==========================================

  function ensureGifts() {
    var styleId = 'zone2-kaching-grouped-gift-order-styles';

    if (!document.getElementById(styleId)) {
      var style = document.createElement('style');
      style.id = styleId;

      style.textContent =
        '[data-zone2-gift-order] > .kaching-bundles__free-gift + ' +
        '.kaching-bundles__free-gift {' +
          'border-top: 1px solid #fff !important;' +
        '}' +

        '[data-zone2-gift-order] > .kaching-bundles__free-gift__divider {' +
          'height: 1px !important;' +
          'background: #fff !important;' +
          'border: 0 !important;' +
        '}' +

        '[data-zone2-grouped-flasks] .kaching-bundles__free-gift__image {' +
          'width: 80px !important;' +
          'height: 40px !important;' +
          'max-width: none !important;' +
          'object-fit: contain !important;' +
        '}' +

        '[data-zone2-grouped-flasks] .kaching-bundles__free-gift__link {' +
          'width: auto !important;' +
          'flex-shrink: 0 !important;' +
        '}' +

        '[data-zone2-grouped-flasks] .kaching-bundles__free-gift__image[hidden] {' +
          'display: none !important;' +
        '}';

      (document.head || document.documentElement).appendChild(style);
    }

    Object.keys(config.gifts).forEach(function (barId) {
      document.querySelectorAll(
        '[data-deal-bar-id="' + barId + '"]'
      ).forEach(function (bar) {
        var wrapper = bar.querySelector('.kaching-bundles__bar-wrapper');
        if (!wrapper) return;

        var container = wrapper.parentElement;
        var amount = config.gifts[barId];

        var grouped = config.groupFlasks === true && amount > 1;
        var flaskRows = grouped ? 1 : amount;

        var extra = config.extraGift || config.shippingGift;

        var addExtra = extra && (
          extra.barId === barId ||
          (
            Array.isArray(extra.barIds) &&
            extra.barIds.indexOf(barId) !== -1
          )
        );

        // Dezelfde onderaan-zetten-logica voor verzendcadeau en vest Mystery Gift.
        var extraLast = addExtra && (
          extra === config.shippingGift || extra.last === true
        );

        if (!container.hasAttribute('data-zone2-gift-order')) {
          container.setAttribute('data-zone2-gift-order', '1');
        }

        // Verwijder oude losse flaskregels bij een gegroepeerde bundel.
        // Verzendregel behoudt nummer amount + 1.
        if (grouped) {
          for (var staleIndex = 2; staleIndex <= amount; staleIndex++) {
            bar.querySelectorAll(
              '[' + GIFT_ATTR + '="' + staleIndex + '"], ' +
              '[' + DIVIDER_ATTR + '="' + staleIndex + '"]'
            ).forEach(function (node) {
              node.remove();
            });
          }
        }

        function placeGift(index, type, anchor) {
          var divider = bar.querySelector(
            '[' + DIVIDER_ATTR + '="' + index + '"]'
          );

          var gift = bar.querySelector(
            '[' + GIFT_ATTR + '="' + index + '"]'
          );

          if (!divider) {
            divider = document.createElement('div');
            divider.className = 'kaching-bundles__free-gift__divider';
            divider.setAttribute(DIVIDER_ATTR, String(index));
          }

          // Zet een bestaande losse eerste flaskregel om
          // naar de nieuwe samengevoegde flaskregel.
          if (
            gift &&
            type === 'flask-group' &&
            gift.getAttribute('data-zone2-grouped-flasks') !== String(amount)
          ) {
            var replacement = createGift(index, amount, type);
            gift.replaceWith(replacement);
            gift = replacement;
          }

          if (!gift) {
            gift = createGift(index, amount, type);
          }

          // Alleen verplaatsen wanneer de volgorde niet klopt.
          if (
            anchor.nextElementSibling !== divider ||
            divider.nextElementSibling !== gift
          ) {
            anchor.after(divider, gift);
          }

          return gift;
        }

        var total = flaskRows + (addExtra && !extraLast ? 1 : 0);
        var anchor = wrapper;

        for (var i = 1; i <= total; i++) {
          anchor = placeGift(
            i,
            i <= flaskRows
              ? (grouped ? 'flask-group' : 'flask')
              : 'extra',
            anchor
          );
        }

        // Zet het extra cadeau onder alle overige cadeaus uit Kaching.
        // Belt/Zipper: GRATIS Verzending na Running Lights.
        // Vest: Mystery Gift na de extra Kaching-gift (bijv. 3 paar sokken).
        if (extraLast) {
          var extraIndex = amount + 1;

          Array.prototype.forEach.call(
            container.children,
            function (child) {
              if (
                child.matches('.kaching-bundles__free-gift') &&
                child.getAttribute(GIFT_ATTR) !== String(extraIndex)
              ) {
                anchor = child;
              }
            }
          );

          placeGift(extraIndex, 'extra', anchor);
        }
      });
    });
  }

  // ==========================================
  // KLEURAFBEELDINGEN IN DE DROPDOWN
  // ==========================================

  function cssImageUrl(value) {
    var str = String(value || '').trim();
    var match = str.match(/^url\(\s*(.*?)\s*\)$/i);

    return match
      ? match[1].replace(/^["']|["']$/g, '').trim()
      : str;
  }

  function fullUrl(value) {
    try {
      return new URL(cssImageUrl(value), document.baseURI).href;
    } catch (e) {
      return '';
    }
  }

  function getOverrideByColor(color) {
    color = normalizeColor(color);

    var swaps = config.imageOverrides || [];

    for (var i = 0; i < swaps.length; i++) {
      if (normalizeColor(swaps[i].color) === color) {
        return swaps[i];
      }
    }

    return null;
  }

  function updateSwatch(swatch) {
    var listOption = swatch.closest(
      '.kaching-bundles__swatch-dropdown__option[data-value]'
    );

    var selectedOption = swatch.closest(COLOR_DROPDOWN_SELECTOR);

    var color = listOption
      ? listOption.getAttribute('data-value')
      : (
          selectedOption
            ? selectedOption.getAttribute('data-value')
            : ''
        );

    if (!color) return;

    var swap = getOverrideByColor(color);
    if (!swap || !swap.new) return;

    var current = swatch.style.getPropertyValue(
      '--kaching-swatch-image-url'
    );

    if (fullUrl(current) === fullUrl(swap.new)) return;

    swatch.style.setProperty(
      '--kaching-swatch-image-url',
      'url("' + swap.new + '")'
    );
  }

  function ensureSwaps() {
    document.querySelectorAll(
      '.kaching-bundles__swatch'
    ).forEach(updateSwatch);
  }

  // ==========================================
  // VARIANTAFBEELDINGEN VAN BELTS EN VESTEN
  // ==========================================

  function ensureVariantImages() {
      (config.variantImageBars || Object.keys(config.gifts))
    .forEach(function (barId) {
      document.querySelectorAll(
        '[data-deal-bar-id="' + barId + '"] ' +
        '.kaching-bundles__bar-variant__content'
      ).forEach(function (content) {
        var number = content.querySelector(
          '.kaching-bundles__bar-variant-number'
        );

        var img = content.querySelector(
          '.kaching-bundles__bar-variant-image'
        );

        var main = content.querySelector(
          '.kaching-bundles__bar-variant-main'
        );

        if (!main) return;

        var option = content.querySelector(COLOR_DROPDOWN_SELECTOR);
        if (!option) return;

        var color = (
          option.getAttribute('data-value') || ''
        ).trim().toUpperCase();

        var productName = config.productName || 'Running Belt';
        var swap = getOverrideByColor(color);
        var image = swap && swap.new ? swap.new : '';

        if (!image) {
          var swatch = option.querySelector(
            '.kaching-bundles__swatch'
          );

          if (swatch) {
            image = cssImageUrl(
              swatch.style.getPropertyValue(
                '--kaching-swatch-image-url'
              )
            );
          }
        }

        if (!image) return;

        if (!img) {
          img = document.createElement('img');
          img.className = 'kaching-bundles__bar-variant-image';
          img.src = image;
          img.alt = color ? color + ' ' + productName : productName;
          img.loading = 'eager';
          img.decoding = 'async';

          if (number) {
            number.replaceWith(img);
          } else {
            content.insertBefore(img, main);
          }
        } else {
          if (img.getAttribute('src') !== image) {
            img.src = image;
          }

          img.alt = color ? color + ' ' + productName : productName;

          if (img.nextElementSibling !== main) {
            content.insertBefore(img, main);
          }

          // Kaching kan het #nummer opnieuw toevoegen zonder de foto te wissen.
          if (number) number.remove();
        }
      });
    });
  }

  // ==========================================
  // AUTOMATISCH HERSTELLEN NA KACHING RERENDERS
  // ==========================================

  function run() {
    scheduled = false;

    ensureGifts();
    ensureSwaps();
    ensureVariantImages();
  }

  function schedule() {
    if (scheduled) return;

    scheduled = true;
    window.requestAnimationFrame(run);
  }

  new MutationObserver(function (mutations) {
    var needsRun = false;

    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];

      if (
        mutation.type === 'attributes' &&
        mutation.target.matches &&
        mutation.target.matches('.kaching-bundles__swatch')
      ) {
        updateSwatch(mutation.target);
        needsRun = true;
      }

      // Herstel de variantfoto als Kaching deze overschrijft.
      // Werkt ook voor Zipper 2+1 (5qBw) en alle bestaande balken.
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'src' &&
        mutation.target.matches &&
        mutation.target.matches('.kaching-bundles__bar-variant-image')
      ) {
        var imageBar = mutation.target.closest('[data-deal-bar-id]');

        if (imageBar) {
          var barId = imageBar.getAttribute('data-deal-bar-id');

          if (
            config.gifts[barId] ||
            (
              config.variantImageBars &&
              config.variantImageBars.indexOf(barId) !== -1
            )
          ) {
            needsRun = true;
          }
        }
      }

      if (
        mutation.type === 'childList' ||
        (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'data-value'
        )
      ) {
        needsRun = true;
      }
    }

    if (needsRun) schedule();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'data-value', 'src']
  });

  window.addEventListener('pageshow', schedule);
  schedule();
})();


/*
 * ZONE2 - Cadeau-afbeeldingen.
 *
 * Open belt:
 * - 1 belt: losse flaskfoto.
 * - 2 belts: één combinatiefoto met 2 flasks.
 * - 2 + 1: één combinatiefoto met 3 flasks.
 *
 * Zipper 2 BELTS: één ZZ-combinatiefoto met 2 zwarte flasks.
 * Zipper 2+1: één ZZZ-combinatiefoto met 3 zwarte flasks.
 * Vest behoudt de bestaande foto-updater.
 *
 * Alleen visuele weergave:
 * dit wijzigt geen producten of winkelmandregels.
 */
;(function () {
  'use strict';

  // ==========================================
  // VUL HIER JE COMBINATIEFOTO'S IN
  // ==========================================

  /*
   * W = WIT
   * R = ROZE
   * Z = ZWART
   *
   * De code volgt exact de volgorde van de beltkeuzes.
   *
   * Voorbeelden:
   * Wit + roze          -> WR
   * Roze + wit          -> RW
   * Wit + roze + zwart  -> WRZ
   *
   * Neem een echte afbeeldings-URL en vervang alleen
   * de combinatiecode in de bestandsnaam door {code}.
   *
   * Voorbeeld van een URL-patroon:
   * https://jouw-afbeeldingslocatie/files/{code}.png
   *
   * Vul de juiste extensie en hoofdletters in.
   *
   * Lege waarden:
   * de samengevoegde cadeau-regel wordt getoond,
   * maar de combinatiefoto blijft verborgen.
   */

  var COMBINATION_IMAGE_TEMPLATES = {
  2: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/{code}-1.png',
  3: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/{code}-1.png'
  };

  var COMBINATION_IMAGE_URLS = {
  2: {},
  3: {}
};


  /*
   * Optioneel: exacte links voor specifieke combinaties.
   *
   * Deze hebben voorrang op het URL-patroon hierboven.
   * Handig als Shopify een bestandsnaam heeft aangepast.
   *
   * Voorbeeld:
   *
   * 2: {
   *   WR: 'VOLLEDIGE_URL_VAN_JE_WR_AFBEELDING'
   * },
   * 3: {
   *   WRZ: 'VOLLEDIGE_URL_VAN_JE_WRZ_AFBEELDING'
   * }
   */



  var COLOR_CODES = {
    WIT: 'W',
    ROZE: 'R',
    ZWART: 'Z'
  };

  // ==========================================
  // LOSSE FLASKFOTO'S
  // ==========================================

  var GIFT_IMAGE_OVERRIDES = [
    {
      color: 'ZWART',
      new: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/300_-_z_72d7ba05-199b-4409-b1a4-01f777f17738.jpg?v=1763464416'
    },
    {
      color: 'WIT',
      new: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/300_-_b_10d9a22b-ea15-46d9-a88e-0a0e378a6976_1.png?v=1763464416'
    },
    {
      color: 'ROZE',
      new: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/300_-_b_10d9a22b-ea15-46d9-a88e-0a0e378a6976_2.png?v=1763464416'
    }
  ];

  // ==========================================
  // FLASKFOTO'S VOOR VESTEN
  // ==========================================

  var VEST_GIFT_IMAGE_OVERRIDES = [
    {
      color: 'ZWART',
      new: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/2_zwarte_flasks_11c586b4-92ee-4c40-a997-4be124b0eee3.png?v=1778597104'
    },
    {
      color: 'WIT',
      new: 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/2_witte_flasks.png?v=1778597104'
    }
  ];

  // ==========================================
  // AANTALLEN PER BAR
  // ==========================================

  var BELT_GIFT_BARS = {
    '8706d602-5051-4148-a55c-ece363b17376': 1,
    '7ab23c40-ae8f-45de-8bcb-5b03e9461c1b': 2,
    'd_cS': 3,
    '2d0a313b-b37a-4b01-8cab-557734d26692': 1,
    '67d7ba44-f0d3-4a1a-abe3-4107b151bb66': 3
  };

  var ZIPPER_GIFT_BARS = {
    'd73fc8e3-f1a0-4f09-a767-328c3ba6807c': 1,
    '89f42fd8-96e6-44dc-8c3b-b4aa7576d41b': 2,
    '5qBw': 3 // Drie gratis flasks bij het 2+1-aanbod.
  };

  var VEST_GIFT_BARS = {
    '982b659d-cd19-4fcc-89e9-122c203bb8a7': 1,
    '4a53a0d8-6cb8-4cde-9864-0c2f312fbcf3': 2
  };

  // ==========================================
  // PRODUCTEN EN ALIASES
  // ==========================================

  var GIFT_PRODUCTS = {
    'running-belt-bundel-wit': BELT_GIFT_BARS,
    'running-belt-inclusief-flask': BELT_GIFT_BARS,
    'running-belt-bundel-2': BELT_GIFT_BARS,
    'running-belt-zipper-inclusief-flask': ZIPPER_GIFT_BARS,
    'running-belt-zipper-bundel-2': ZIPPER_GIFT_BARS,
    'running-vest-inclusief-2-flasks': VEST_GIFT_BARS,
    'running-vest-bundel-2': VEST_GIFT_BARS
  };

  GIFT_PRODUCTS['running-vest-including-2-flasks'] =
    GIFT_PRODUCTS['running-vest-inclusief-2-flasks'];

  GIFT_PRODUCTS['running-belt-including-flask'] =
    GIFT_PRODUCTS['running-belt-inclusief-flask'];

  GIFT_PRODUCTS['running-belt-zipper-including-flask'] =
    GIFT_PRODUCTS['running-belt-zipper-inclusief-flask'];

  GIFT_PRODUCTS['running-vest-bundle-2'] =
    GIFT_PRODUCTS['running-vest-bundel-2'];

  GIFT_PRODUCTS['running-belt-bundle-2'] =
    GIFT_PRODUCTS['running-belt-bundel-2'];

  GIFT_PRODUCTS['running-belt-zipper-bundle-2'] =
    GIFT_PRODUCTS['running-belt-zipper-bundel-2'];

  GIFT_PRODUCTS['running-belt-bundel'] =
    GIFT_PRODUCTS['running-belt-inclusief-flask'];

    GIFT_PRODUCTS['running-belt-bundel-listicle'] =
  BELT_GIFT_BARS;

  GIFT_PRODUCTS['running-vest-bundel'] =
    GIFT_PRODUCTS['running-vest-inclusief-2-flasks'];

  // ==========================================
  // ACTIEVE CONFIGURATIE
  // ==========================================

  var pageMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
  if (!pageMatch) return;

  var barAmounts = GIFT_PRODUCTS[decodeURIComponent(pageMatch[1])];
  if (!barAmounts) return;

  var giftOverrides = barAmounts === VEST_GIFT_BARS
    ? VEST_GIFT_IMAGE_OVERRIDES
    : GIFT_IMAGE_OVERRIDES;

  var BAR_SELECTOR = '[data-deal-bar-id]';

  var COLOR_SELECTOR =
    '.kaching-bundles-option[data-name="Kleur"], ' +
    '.kaching-bundles-option[data-name="Color"], ' +
    '.kaching-bundles-option[data-name="Colour"]';

  var GIFT_ATTR = 'data-zone2-new-kaching-gift';
  var GIFT_IMAGE_SELECTOR = '.kaching-bundles__free-gift__image';

  var imagesByColor = Object.create(null);
  var preloadedImages = [];
  var preloadedUrls = Object.create(null);

  var COLOR_ALIASES = {
    BLACK: 'ZWART',
    WHITE: 'WIT',
    PINK: 'ROZE'
  };

  function normalizeColor(value) {
    var color = String(value || '').trim().toUpperCase();
    return COLOR_ALIASES[color] || color;
  }

  // ==========================================
  // LOSSE FLASKFOTO'S VOORLADEN
  // ==========================================

  giftOverrides.forEach(function (override) {
    var color = normalizeColor(override.color);

    if (!color || !override.new) return;

    imagesByColor[color] = override.new;

    if (preloadedUrls[override.new]) return;

    preloadedUrls[override.new] = true;

    var image = new Image();
    image.src = override.new;
    preloadedImages.push(image);

    if (image.decode) {
      image.decode().catch(function () {});
    }
  });

  // ==========================================
  // COMBINATIECODE MAKEN
  // ==========================================

  function getCombinationKey(bar, amount) {
    var variants = bar.querySelectorAll(
      '.kaching-bundles__bar-variant'
    );

    if (variants.length < amount) return '';

    var key = '';

    for (var i = 0; i < amount; i++) {
      var option = variants[i].querySelector(COLOR_SELECTOR);
      if (!option) return '';

      var color = normalizeColor(
        option.tagName === 'SELECT'
          ? option.value
          : option.getAttribute('data-value')
      );

      var code = COLOR_CODES[color];
      if (!code) return '';

      key += code;
    }

    return key;
  }

  // ==========================================
  // JUISTE AFBEELDINGS-URL OPHALEN
  // ==========================================

  function getCombinationImageUrl(key, amount) {
    if (!key || key.length !== amount) return '';

    var exactUrls = COMBINATION_IMAGE_URLS[amount] || {};
    var exactUrl = String(exactUrls[key] || '').trim();

    if (exactUrl) return exactUrl;

    var template = String(
      COMBINATION_IMAGE_TEMPLATES[amount] || ''
    ).trim();

    if (template.indexOf('{code}') === -1) return '';

    return template.replace(/\{code\}/g, key);
  }

  // ==========================================
  // COMBINATIEFOTO BIJWERKEN
  // ==========================================


    var combinationImageCache = Object.create(null);
  var pendingCombinationRequests = new WeakMap();

  function getFastCombinationSource(key, amount) {
    var source = getCombinationImageUrl(key, amount);
    if (!source) return '';

    try {
      var url = new URL(source, document.baseURI);

      // Scherpe afbeelding voor de bestaande weergave van 80px.
      if (url.hostname === 'cdn.shopify.com') {
        url.searchParams.set('width', '240');
      }

      return url.href;
    } catch (error) {
      return source;
    }
  }

  function prepareCombinationImage(source) {
    if (combinationImageCache[source]) {
      return combinationImageCache[source];
    }

    var preload = new Image();
    preload.loading = 'eager';
    preload.decoding = 'async';

    var entry = {
      image: preload,
      ready: false,
      promise: null
    };

    combinationImageCache[source] = entry;

    entry.promise = new Promise(function (resolve) {
      preload.onerror = function () {
        resolve(false);
      };

      preload.onload = function () {
        function finish() {
          entry.ready = preload.naturalWidth > 0;
          resolve(entry.ready);
        }

        // Vooraf decoderen, zodat dit niet tijdens de klik hoeft.
        Promise.resolve().then(function () {
          if (typeof preload.decode === 'function') {
            return preload.decode();
          }
        }).then(finish, finish);
      };

      preload.src = source;
    });

    return entry;
  }

  function preloadCombinationImages() {
    if (barAmounts !== BELT_GIFT_BARS &&
        barAmounts !== ZIPPER_GIFT_BARS) return;

    // Eerst de combinaties die momenteel zijn geselecteerd.
    Object.keys(barAmounts).forEach(function (barId) {
      var amount = barAmounts[barId];
      if (amount < 2) return;

      document.querySelectorAll(
        '[data-deal-bar-id="' + barId + '"]'
      ).forEach(function (bar) {
        var key = getCombinationKey(bar, amount);
        var source = getFastCombinationSource(key, amount);

        if (source) {
          prepareCombinationImage(source);
        }
      });
    });

    // Zipper heeft maar één flessenkleur: ZZ (2 stuks) of ZZZ (3 stuks).
    // Beide foto's vooraf laden, ook als de balk nog niet in de DOM staat.
    if (barAmounts === ZIPPER_GIFT_BARS) {
      [['ZZ', 2], ['ZZZ', 3]].forEach(function (combination) {
        var zipperSource = getFastCombinationSource(combination[0], combination[1]);
        if (zipperSource) prepareCombinationImage(zipperSource);
      });
      return;
    }

    // Open belt: daarna alle 9 + 27 combinaties vooraf laden.
    var letters = ['W', 'R', 'Z'];

    function preloadCode(prefix, remaining, amount) {
      if (remaining === 0) {
        var source = getFastCombinationSource(prefix, amount);

        if (source) {
          prepareCombinationImage(source);
        }

        return;
      }

      letters.forEach(function (letter) {
        preloadCode(prefix + letter, remaining - 1, amount);
      });
    }

    preloadCode('', 2, 2);
    preloadCode('', 3, 3);
  }

  function updateCombinationImage(bar, amount) {
    var gift = bar.querySelector(
      '[' + GIFT_ATTR + '="1"][data-zone2-grouped-flasks]'
    );

    if (!gift) return;

    var image = gift.querySelector(GIFT_IMAGE_SELECTOR);
    if (!image) return;

    var key = getCombinationKey(bar, amount);
    var source = getFastCombinationSource(key, amount);

    // Houd de huidige foto zichtbaar tijdens een tijdelijke rerender.
    if (!source) {
      pendingCombinationRequests.delete(image);
      return;
    }

    // Verwijder oude handlers die de foto tijdens laden verbergen.
    image.onload = null;
    image.onerror = null;

    var entry = prepareCombinationImage(source);

    function showImage() {
      // Een eerdere, langzamere keuze mag de nieuwste niet overschrijven.
      if (!bar.isConnected || !image.isConnected) return;
      if (gift.querySelector(GIFT_IMAGE_SELECTOR) !== image) return;
      if (getCombinationKey(bar, amount) !== key) return;

      if (image.getAttribute('src') !== source) {
        image.loading = 'eager';
        image.decoding = 'sync';

        image.style.setProperty(
          'transition',
          'none',
          'important'
        );

        image.style.setProperty(
          'animation',
          'none',
          'important'
        );

        image.setAttribute('src', source);
      }

      if (image.getAttribute('data-zone2-combination-key') !== key) {
        image.setAttribute('data-zone2-combination-key', key);
      }

      var alt = amount + 'x Soft Flask 300 ML (' + key + ')';

      if (image.alt !== alt) {
        image.alt = alt;
      }

      if (image.hidden) {
        image.hidden = false;
      }
    }

    // Al voorgeladen: direct wisselen, zonder timer of extra animatieframe.
    if (entry.ready) {
      pendingCombinationRequests.delete(image);
      showImage();
      return;
    }

    var previous = pendingCombinationRequests.get(image);

    if (
      previous &&
      previous.source === source &&
      previous.key === key
    ) {
      return;
    }

    var request = {
      source: source,
      key: key
    };

    pendingCombinationRequests.set(image, request);

    // Nog niet geladen: laat de huidige foto staan totdat de nieuwe klaar is.
    entry.promise.then(function (loaded) {
      if (pendingCombinationRequests.get(image) !== request) return;

      pendingCombinationRequests.delete(image);

      if (loaded) {
        showImage();
      }
    });
  }

  preloadCombinationImages();



  // ==========================================
  // CADEAUFOTO'S BIJWERKEN
  // ==========================================

  function updateGiftImages(bar) {
    if (!bar.isConnected) return;

    var amount = barAmounts[
      bar.getAttribute('data-deal-bar-id')
    ];

    if (!amount) return;

    // Open belt en Zipper: één combinatiefoto in een gegroepeerde cadeau-regel.
    if ((barAmounts === BELT_GIFT_BARS ||
         barAmounts === ZIPPER_GIFT_BARS) && amount > 1) {
      updateCombinationImage(bar, amount);
      return;
    }

    // Overige bars behouden losse cadeau-afbeeldingen.
    var variants = bar.querySelectorAll(
      '.kaching-bundles__bar-variant'
    );

    for (var i = 0; i < amount; i++) {
      var variant = variants[i];
      if (!variant) continue;

      var option = variant.querySelector(COLOR_SELECTOR);
      if (!option) continue;

      var color = normalizeColor(
        option.tagName === 'SELECT'
          ? option.value
          : option.getAttribute('data-value')
      );

      var source = imagesByColor[color] || imagesByColor.ZWART;
      if (!source) continue;

      var image = bar.querySelector(
        '[' + GIFT_ATTR + '="' + (i + 1) + '"] ' +
        GIFT_IMAGE_SELECTOR
      );

      if (!image) continue;

      if (image.getAttribute('src') !== source) {
        image.setAttribute('src', source);
      }
    }
  }

  // ==========================================
  // GEWIJZIGDE BARS VERZAMELEN
  // ==========================================

  function collectBar(node, bars) {
    if (!node || node.nodeType !== 1) return false;

    var bar = node.closest(BAR_SELECTOR);

    if (
      !bar ||
      !barAmounts[bar.getAttribute('data-deal-bar-id')]
    ) {
      return false;
    }

    bars.add(bar);
    return true;
  }

  function collectAddedBars(node, bars) {
    if (!node || node.nodeType !== 1) return;
    if (collectBar(node, bars)) return;

    node.querySelectorAll(BAR_SELECTOR).forEach(function (bar) {
      collectBar(bar, bars);
    });
  }

  function updateAllGiftImages() {
    Object.keys(barAmounts).forEach(function (barId) {
      document.querySelectorAll(
        '[data-deal-bar-id="' + barId + '"]'
      ).forEach(updateGiftImages);
    });
  }

  // ==========================================
  // DIRECT REAGEREN OP KLEURWIJZIGINGEN
  // ==========================================

  function onColorChange(event) {
    var target = event.target;

    if (!target || !target.closest) return;

    var option = target.closest(COLOR_SELECTOR);
    if (!option) return;

    var bar = option.closest(BAR_SELECTOR);

    if (bar) {
      updateGiftImages(bar);
    }
  }

  document.addEventListener('input', onColorChange, true);
  document.addEventListener('change', onColorChange, true);

  // ==========================================
  // HERSTELLEN NA KACHING RERENDERS
  // ==========================================

  new MutationObserver(function (mutations) {
    var bars = new Set();

    mutations.forEach(function (mutation) {
      if (mutation.type === 'attributes') {
        var target = mutation.target;

        if (
          (
            mutation.attributeName === 'data-value' &&
            target.matches(COLOR_SELECTOR)
          ) ||
          (
            mutation.attributeName === 'src' &&
            target.matches(GIFT_IMAGE_SELECTOR)
          )
        ) {
          collectBar(target, bars);
        }

        return;
      }

      collectBar(mutation.target, bars);

      mutation.addedNodes.forEach(function (node) {
        collectAddedBars(node, bars);
      });
    });

    bars.forEach(updateGiftImages);
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-value', 'src']
  });

  window.addEventListener('pageshow', updateAllGiftImages);
  updateAllGiftImages();
})();



/* =========================================================
   ZONE2 - BESTSELLERS (VEST + BELT)
   Toevoegen ONDERAAN new-kaching-zone2.js
   Alleen Kaching bar ILwJ; andere deals blijven onaangetast.
   Visuele cadeauregels: geen echte cart-items!
========================================================= */
(function () {
  'use strict';

  var BAR_SELECTOR = '.kaching-bundles__bar[data-deal-bar-id="ILwJ"]';
  var BASE = 'https://cdn.shopify.com/s/files/1/0866/9541/2059/files/';

  var IMAGES = {
    vest: {
      ZWART: BASE + 'zwart_voor.png?v=1776548918',
      WIT: BASE + 'wit_voor.png?v=1776548918'
    },
    belt: {
      ZWART: BASE + 'belt_bf87dc95-1b8e-4e2c-b70e-d14cd451feb8.jpg?v=1763463436',
      WIT: BASE + 'White_belt.png?v=1763463436',
      ROZE: BASE + 'Pink_belt.png?v=1763463436'
    },
    flask500: {
      ZWART: BASE + '2_zwarte_flasks_11c586b4-92ee-4c40-a997-4be124b0eee3.png?v=1778597104',
      WIT: BASE + '2_witte_flasks.png?v=1778597104'
    },
    flask300: {
      ZWART: BASE + '300_-_z_72d7ba05-199b-4409-b1a4-01f777f17738.jpg?v=1763464416',
      WIT: BASE + '300_-_b_10d9a22b-ea15-46d9-a88e-0a0e378a6976_1.png?v=1763464416',
      ROZE: BASE + '300_-_b_10d9a22b-ea15-46d9-a88e-0a0e378a6976_2.png?v=1763464416'
    },
    mystery: BASE + 'Mystery_gift.png?v=1790081872'
  };

  var COLOR_SELECTOR = '.kaching-bundles__swatch-dropdown[data-name="Kleur"], ' +
    '.kaching-bundles__swatch-dropdown[data-name="Color"], ' +
    '.kaching-bundles__swatch-dropdown[data-name="Colour"]';

  var GIFTS = [
    { key: '500', text: '+ 2x GRATIS Soft Flask 500 ML', price: '19,95', height: 40, width: 80 },
    { key: '300', text: '+ GRATIS Soft Flask 300 ML', price: '10,95', height: 40, width: 40 },
    { key: 'mystery', text: '+ GRATIS Mystery Gift', price: '', height: 40, width: 40 }
  ];

  function colorOf(card) {
    var selector = card && card.querySelector(COLOR_SELECTOR);
    var value = selector ? (selector.getAttribute('data-value') || '') : '';
    var aliases = { BLACK: 'ZWART', WHITE: 'WIT', PINK: 'ROZE' };
    value = value.trim().toUpperCase();
    return aliases[value] || value || 'ZWART';
  }

  function setImg(img, url) {
    if (!img || !url) return;
    if (img.getAttribute('src') !== url) img.setAttribute('src', url);

    // Kaching kan na een variantwissel opnieuw een srcset plaatsen.
    if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
  }

  function setSwatch(swatch, url) {
    if (!swatch || !url) return;
    var desired = 'url("' + url + '")';
    if (swatch.style.getPropertyValue('--kaching-swatch-image-url') !== desired) {
      swatch.style.setProperty('--kaching-swatch-image-url', desired);
    }
  }

  function updateProduct(card, type) {
    if (!card) return 'ZWART';
    var colors = IMAGES[type];
    var color = colorOf(card);
    var url = colors[color] || colors.ZWART;

    setImg(card.querySelector('.kaching-bundles__bundle-products__image'), url);

    var dropdown = card.querySelector(COLOR_SELECTOR);
    if (!dropdown) return color;

    // Huidige geselecteerde kleur in de selector.
    setSwatch(dropdown.querySelector('.kaching-bundles__bar-variant-select .kaching-bundles__swatch'), url);

    // Kleurkeuzes in de geopende dropdown (indien al gerenderd).
    var choices = dropdown.querySelectorAll('.kaching-bundles__swatch-dropdown__option[data-value]');
    choices.forEach(function (choice) {
      var value = choice.getAttribute('data-value').trim().toUpperCase();
      var aliases = { BLACK: 'ZWART', WHITE: 'WIT', PINK: 'ROZE' };
      value = aliases[value] || value;
      setSwatch(choice.querySelector('.kaching-bundles__swatch'), colors[value]);
    });

    // Sommige Kaching-versies plaatsen de dropdownlijst buiten de selector.
    var trigger = dropdown.querySelector('[aria-controls]');
    var popupId = trigger && trigger.getAttribute('aria-controls');
    var popup = popupId && document.getElementById(popupId);

    if (popup && !dropdown.contains(popup)) {
      popup.querySelectorAll('[data-value]').forEach(function (choice) {
        var value = choice.getAttribute('data-value').trim().toUpperCase();
        var aliases = { BLACK: 'ZWART', WHITE: 'WIT', PINK: 'ROZE' };
        value = aliases[value] || value;
        setSwatch(choice.querySelector('.kaching-bundles__swatch'), colors[value]);
      });
    }

    return color;
  }

  function createGift(info) {
    var gift = document.createElement('div');
    gift.className = 'kaching-bundles__free-gift';
    gift.setAttribute('data-zone2-best-gift', info.key);

    gift.style.cssText =
      '--kaching-free-gift-background-color:rgba(141,141,141,1);' +
      '--kaching-free-gift-text-color:rgba(255,255,255,1);' +
      '--kaching-free-gift-selected-background-color:rgba(0,0,0,1);' +
      '--kaching-free-gift-selected-text-color:rgba(255,255,255,1);' +
      '--kaching-free-gift-font-size:13px;' +
      '--kaching-free-gift-font-weight:500;' +
      '--kaching-free-gift-image-border-radius:4px;' +
      '--kaching-free-gift-image-height:' + info.height + 'px;';

    gift.innerHTML =
      '<div class="kaching-bundles__free-gift__main">' +
        '<div class="kaching-bundles__free-gift__link">' +
          '<img class="kaching-bundles__free-gift__image" alt="" ' +
            'width="' + info.width + '" height="' + info.height + '">' +
        '</div>' +
        '<div class="kaching-bundles__free-gift__content">' +
          '<span class="kaching-bundles__free-gift__text"></span>' +
        '</div>' +
      '</div>' +
      (info.price ? '<div class="kaching-bundles__free-gift__full-price">' + info.price + '</div>' : '');

    gift.querySelector('.kaching-bundles__free-gift__text').textContent = info.text;
    return gift;
  }

  function ensureGifts(bar) {
    var wrapper = bar.querySelector('.kaching-bundles__bar-wrapper');
    var container = bar.querySelector('.kaching-bundles__bar-container');
    if (!container || !wrapper) return;

    var anchor = wrapper;

    GIFTS.forEach(function (info) {
      var selector = '[data-zone2-best-gift="' + info.key + '"]';
      var dividerSelector = '[data-zone2-best-divider="' + info.key + '"]';

      var divider = container.querySelector(dividerSelector);
      var gift = container.querySelector(selector);

      if (!divider) {
        divider = document.createElement('div');
        divider.className = 'kaching-bundles__free-gift__divider';
        divider.setAttribute('data-zone2-best-divider', info.key);
      }

      if (!gift) gift = createGift(info);

      // Geen onnodige DOM-wijzigingen => geen MutationObserver-loop.
      if (anchor.nextElementSibling !== divider || divider.nextElementSibling !== gift) {
        anchor.after(divider, gift);
      }

      anchor = gift;
    });
  }

  function update(bar) {
    var products = bar.querySelectorAll(
      '.kaching-bundles__bundle-products--vertical .kaching-bundles__bundle-products__product'
    );

    if (products.length < 2) return;

    // Dit is de volgorde van de twee bundleProducts in Kaching.
    var vestColor = updateProduct(products[0], 'vest');
    var beltColor = updateProduct(products[1], 'belt');

    ensureGifts(bar);

    setImg(
      bar.querySelector('[data-zone2-best-gift="500"] img'),
      IMAGES.flask500[vestColor] || IMAGES.flask500.ZWART
    );

    setImg(
      bar.querySelector('[data-zone2-best-gift="300"] img'),
      IMAGES.flask300[beltColor] || IMAGES.flask300.ZWART
    );

    setImg(
      bar.querySelector('[data-zone2-best-gift="mystery"] img'),
      IMAGES.mystery
    );
  }

  // Eenmalige styling uitsluitend voor deze nieuwe nep-gifts.
  if (!document.getElementById('z2-best-bundle-gift-style')) {
    var style = document.createElement('style');
    style.id = 'z2-best-bundle-gift-style';

    style.textContent =
      '[data-zone2-best-divider]{height:1px!important;background:#fff!important;border:0!important;}' +
      '[data-zone2-best-gift="500"] .kaching-bundles__free-gift__image{' +
        'width:80px!important;height:40px!important;max-width:none!important;object-fit:contain!important;}' +
    '.kaching-bundles [data-zone2-best-gift="300"] .kaching-bundles__free-gift__image{' +
      'width:40px!important;height:40px!important;object-fit:contain!important;}' +
      '[data-zone2-best-gift="mystery"] .kaching-bundles__free-gift__image{' +
        'width:40px!important;height:40px!important;object-fit:contain!important;}';

    (document.head || document.documentElement).appendChild(style);
  }

  var scheduled = false;

  function run() {
    scheduled = false;
    document.querySelectorAll(BAR_SELECTOR).forEach(update);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(run);
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      var node = mutation.target;

      if (node.nodeType === 1 && (
        node.closest(BAR_SELECTOR) ||
        (mutation.type === 'childList' && node.querySelector(BAR_SELECTOR))
      )) {
        schedule();
        return;
      }
    }
  }).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['src', 'srcset', 'style', 'data-value']
  });

  window.addEventListener('pageshow', schedule);
  schedule();
})();
